<div class="card default" *ngIf="isShowNotice">
  <div class="card-header" [ngClass]="{ 'broker-entry': isBrokerEntry }">
    <div class="row justify-content-between align-items-center mb-2">
      <div class="col">
        <strong class="card-title">
          {{ (isBrokerEntry ? "ENTRY_SUMMARY.BROKER_ENTRY_SUMMARY" : "ENTRY_SUMMARY.SELF_ENTRY_SUMMARY") | translate }}
        </strong>
      </div>
      <div class="es-actions">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
      </div>
    </div>
    <div class="d-flex">
      <div class="title-block" *ngIf="es.referenceNumber">
        <div class="card-header-date">{{ "LABELS.EEZY_ID" | translate }}</div>
        <div class="card-header-text">
          <strong>{{ es.referenceNumber }}</strong>
        </div>
      </div>

      <div class="title-block pl-3">
        <div class="card-header-date" *ngIf="es.entryNumber">{{ "LABELS.CBP_ID" | translate }}</div>
        <div class="card-header-text" *ngIf="es.entryNumber">
          <strong>{{ es.entryNumber }}</strong>
        </div>
      </div>

      <div
        class="title-block pl-3"
        [ngClass]="{ 'd-none d-sm-block': es.sentToProviderDate && es.releaseDate && es.entryNumber && es.referenceNumber }"
      >
        <ng-template [ngIf]="es.sentToProviderDate || es.receivedByCbpDate">
          <div class="card-header-date">
            {{
              (es.receivedByCbpDate
                ? "STATUS.SECOND_TEXT.RECEIVED_BY_CBP"
                : isBrokerEntry
                ? "LABELS.SENT_TO_BROKER"
                : "LABELS.SENT_TO_PROVIDER"
              ) | translate
            }}
          </div>
          <div class="card-header-text">
            <strong>{{ (es.receivedByCbpDate ? es.receivedByCbpDate : es.sentToProviderDate) | customDateByUtc }}</strong>
          </div>
        </ng-template>
      </div>

      <div class="title-block pl-3">
        <div class="card-header-date" *ngIf="es.releaseDate">
          {{ "LABELS.RELEASED" | translate }}
        </div>
        <div class="card-header-text" *ngIf="es.releaseDate">
          <strong>{{ es.releaseDate | customDateByUtc }}</strong>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="es.duties" class="card-subheader">
    <div class="d-flex align-items-center">
      <span class="pr-2 duties-title">
        {{ "PAYMENT_BREAKDOWN.TOTAL_DUTIES_AND_FEES" | translate }}
      </span>
      <span class="pr-3 duties-value">{{ es.duties.totalDue | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}</span>
      <span class="icon-question-circle-container" (click)="openDutiesModal = !openDutiesModal">
        <icon-question-circle></icon-question-circle>
      </span>
    </div>
  </div>
  <div class="card-body">
    <div class="card-body-status">
      <es-status
        [submissionType]="es.submissionType"
        [state]="es.state"
        [paymentState]="es.paymentState"
        [customState]="es?.customState"
      ></es-status>
    </div>
    <div class="card-body-text" *ngIf="showText" [ngClass]="{ 'text-error': errorColor }">
      <span [innerHTML]="cardBodyText | translate : { code: 'LABELS.ENTRY_SUMMARY' | translate, entryNumber: es.entryNumber }"></span>

      <app-hint-tooltip-icon *ngIf="isShowCustomStateTooltip" [hint]="es?.customState?.internalNotes | translate"></app-hint-tooltip-icon>
    </div>
    <div *ngIf="isShowLoader" class="loader-wrapper">
      <img src="/assets/images/loading.gif" />
    </div>
    <ul *ngIf="cbpMessages.length" class="messages-list">
      <li *ngFor="let message of cbpMessages" [ngClass]="{ 'text-gray': !errorColor }" class="messages-item">
        <span *ngIf="showTranslatedKey(message.key)">
          {{ message.key | translate : message.params }}
        </span>
        <span *ngIf="registerMessage(message.key)">
          {{
            registerMessage(message.key)
              | translate : { code: "LABELS.ENTRY_SUMMARY" | translate, entityType: getEntityTypeText(message.key) | translate }
          }}
        </span>

        <ng-template [ngIf]="showRegisterButton(message.key)">
          <button type="button" class="btn btn-link" [routerLink]="!disableActions ? registerLink(message.key) : null">
            {{ registerButtonText(message.key) | translate }}
          </button>
        </ng-template>

        <button
          *ngIf="showAbiFormLink(message.key)"
          type="button"
          class="btn btn-link"
          [routerLink]="!disableActions ? ['/companies', 'self-filer'] : null"
        >
          {{ "BUTTON.FILER_CODE_NOT_AUTHORIZED_LINK" | translate }}
        </button>
      </li>
    </ul>
    <ul *ngIf="errorMessages.length" class="messages-list">
      <li *ngFor="let message of errorMessages" [ngClass]="{ 'text-gray': !errorColor }" class="messages-item">
        <span *ngIf="showTranslatedKey(message.key)">
          {{ message.key | translate : message.params }}
        </span>
        <span *ngIf="registerMessage(message.key)">
          {{
            registerMessage(message.key)
              | translate : { code: "LABELS.ENTRY_SUMMARY" | translate, entityType: getEntityTypeText(message.key) | translate }
          }}
        </span>

        <ng-template [ngIf]="showRegisterButton(message.key)">
          <button type="button" class="btn btn-link" [routerLink]="!disableActions ? registerLink(message.key) : null">
            {{ registerButtonText(message.key) | translate }}
          </button>
        </ng-template>

        <button
          *ngIf="showAbiFormLink(message.key)"
          type="button"
          class="btn btn-link"
          [routerLink]="!disableActions ? ['/companies', 'self-filer'] : null"
        >
          {{ "BUTTON.FILER_CODE_NOT_AUTHORIZED_LINK" | translate }}
        </button>
      </li>
    </ul>
    <div *ngIf="isShowBrokerChatLink && hasNewBrokerMessages" class="d-flex justify-content-center pt-3">
      <button class="btn btn-outline-secondary" (click)="onGoToBrokerChat()">
        <span class="broker-messages-icon"><icon-envelope></icon-envelope></span>
        {{ (hasNewBrokerMessages ? "BUTTON.CHECK_MESSAGES_FROM_BROKER" : "BUTTON.CHAT_WITH_BROKER") | translate }}
      </button>
    </div>
    <div
      *ngIf="
        isShowCbpLogButton || (isShowSupport && showContactTeem) || isShowBackToEntryLink || (isShowBrokerChatLink && !hasNewBrokerMessages)
      "
      class="d-flex justify-content-between"
    >
      <div>
        <button *ngIf="isShowCbpLogButton" class="btn btn-link" (click)="toggleCbpLog()">{{ "BUTTON.CBP_LOG" | translate }}</button>
        <button *ngIf="isShowBrokerChatLink && !hasNewBrokerMessages" class="btn btn-link" (click)="onGoToBrokerChat()">
          {{ "BUTTON.CHAT_WITH_BROKER" | translate }}
        </button>
        <button *ngIf="isShowBackToEntryLink" class="btn btn-link" (click)="onBackToEntry()">
          {{ "BUTTON.BACK_TO_ENTRY" | translate }}
        </button>
      </div>
      <div>
        <button *ngIf="isShowButtonOpenFiles" class="btn btn-link" (click)="isOpenFilesChange.emit(!this.isOpenFiles)">
          {{ (this.isOpenFiles ? "BUTTON.CLOSE_DOCUMENTS" : "BUTTON.OPEN_DOCUMENTS") | translate }}
        </button>
      </div>
      <div>
        <button *ngIf="isShowSupport && showContactTeem" class="btn btn-link" (click)="contactToSupport()">
          {{ "BUTTON.CONTACT_SUPPORT" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<info
  *ngIf="(showHeaderOnDraft && !isShowNotice) || isPaymentPending"
  [title]="('LABELS.ENTRY_SUMMARY' | translate) + ': ' + es.referenceNumber || ''"
  [subTitle]="isPaymentPending ? 'YOUR_FILING_IS_ON_HOLD' : 'INFO.ES_STATUS.SUB_TITLE'"
>
  <ng-container [ngTemplateOutlet]="content"></ng-container>
</info>

<ng-container *ngIf="isShowAttention">
  <div class="card warning">
    <div class="card-header">
      <div class="card-header-text">
        <i class="icon-ic_simn"></i>
        {{ cardHeaderAttention | translate }}
      </div>
    </div>
    <div class="card-body">
      <div class="card-body-text">{{ cardBodyAttention | translate }}</div>
    </div>
  </div>
</ng-container>

<div *ngIf="isShowCbpLog" class="summary-card p-3 d-print-none">
  <div *ngIf="isShowCbpLogLoader; else cbpLogList" class="loader-wrapper">
    <img src="/assets/images/loading.gif" />
  </div>
  <ng-template #cbpLogList>
    <div class="w-100">
      <cbp-log-message-list [sendToProviderDate]="es.sentToProviderDate" [messageList]="cbpLogMessages"></cbp-log-message-list>
    </div>
  </ng-template>
</div>

<custom-modal [(open)]="openDutiesModal" [header]="'PAYMENT_BREAKDOWN.TOTAL_DUTIES_AND_FEES'">
  <ng-template [ngIf]="es.duties">
    <div class="row">
      <div class="col-9 label">
        {{ "PAYMENT_BREAKDOWN.DUTY_AMOUNT" | translate }}
      </div>
      <div class="col-3 value text-right">
        {{ es.duties.dutyAmount | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
      </div>
    </div>
    <div
      *ngIf="
        es.type === enumEntrySummaryType.FORMAL || (es.type === enumEntrySummaryType.INFORMAL && es.duties.informalMerchandiseProcessingFee)
      "
      class="row"
    >
      <div class="col-9 label">
        {{ "PAYMENT_BREAKDOWN.MERCHANDISE_PROCESSING_FEE" | translate }}
      </div>
      <div class="col-3 value text-right">
        {{
          (es.type === enumEntrySummaryType.FORMAL ? es.duties.formalMerchandiseProcessingFee : es.duties.informalMerchandiseProcessingFee)
            | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2"
        }}
      </div>
    </div>
    <div *ngIf="es.duties.harborMaintenanceFee && es.transportationMode === enumTransportationMode.OCEAN" class="row">
      <div class="col-9 label">
        {{ "PAYMENT_BREAKDOWN.HARBOR_MAINTENANCE_FEE" | translate }}
      </div>
      <div class="col-3 value text-right">
        {{ es.duties.harborMaintenanceFee | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
      </div>
    </div>
    <div *ngIf="es.duties.internalRevenueTax" class="row">
      <div class="col-9 label">
        {{ "PAYMENT_BREAKDOWN.INTERNAL_REVENUE_TAX" | translate }}
      </div>
      <div class="col-3 value text-right">
        {{ es.duties.internalRevenueTax | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
      </div>
    </div>
    <div *ngIf="es.duties.userFee" class="row">
      <div class="col-9 label">
        {{ "PAYMENT_BREAKDOWN.USER_FEE" | translate }}
      </div>
      <div class="col-3 value text-right">
        {{ es.duties.userFee | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-9 total-label">
        <b>
          {{ "PAYMENT_BREAKDOWN.TOTAL_DUTIES_AND_FEES" | translate }}
        </b>
      </div>
      <div class="col-3 total-value text-right">
        <b>
          {{ es.duties.totalDue | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
        </b>
      </div>
    </div>
  </ng-template>
</custom-modal>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
